$(document).ready(function(){
  
  if(window.innerWidth > 767)
  {
  	$('.bxslider').bxSlider({
      "speed" : 225,
      "mode" : "horizontal",
      "infiniteLoop" : true,
      "minSlides" : 4,
      "maxSlides" : 4,
      "moveSlides" : 4,
      "useCSS" : false
    });
  }
  else
  {
  	$('.bxslider').bxSlider({
      "speed" : 225,
      "mode" : "horizontal"
    });
  }
  
  
  $('.pinterest-button').click(function(e){
  	e.stopPropagation();
  });
  
  
  

  	
  $('.carousel .item').each(function(){
    var next = $(this).next();
    if (!next.length) {
      next = $(this).siblings(':first');
    }
    next.children(':first-child').clone().appendTo($(this));

    if (next.next().length>0) {
      next.next().children(':first-child').clone().appendTo($(this));
    }
    else {
      $(this).siblings(':first').children(':first-child').clone().appendTo($(this));
    }
  });

  
  $(".product-description a img").each(function(index, el){
  	$(el).parent().addClass("product-description-recommendation");
    $(el).parent().parent().addClass("product-desc-link");
  });
  
  var lastItem = $(".product-description a img").last();
  $("<div class='clearfix'></div>").insertAfter(lastItem.parent());
  
  
  // make the instagram API call through ajax
  // token = 522361632.f3f0ffe.0c26d89dbafd499d964cbfb16710d95b
  $.ajax({
    url: "https://api.instagram.com/v1/users/522361632/media/recent/?access_token=522361632.f3f0ffe.0c26d89dbafd499d964cbfb16710d95b",
 
    // The name of the callback parameter, as specified by the YQL service
    jsonp: "callback",
 
    // Tell jQuery we're expecting JSONP
    dataType: "jsonp",
 
    // Work with the response
    success: function( response ) {
        
      	console.log(response);
      	// loop through and make the HTML
      	var html = '';
      	for(var i = 0; i < 18; i++)
      	{
      		html += '<div class="insta-item">';
            html += '<a target="_blank" href="'+ response.data[i].link +'" class="insta-overlay">';
            html += '<span><i class="fa fa-heart"></i> &nbsp; '+ response.data[i].likes.count +'</span>';
            html += '</a>';
            html += '<img src="'+ response.data[i].images.standard_resolution.url +'" />';
            html += '</div>';
      	}
      
      	$(".insta-photos-wrapper").append(html);
      	
    }
});


        
  if($("#product-form").length > 0)   
  {
    document.querySelector("#product-form").onsubmit = function(){return false;};
    
    $("#add").click(function(){
    	// show the loader
      	$("#product-loader").fadeIn(175);
      
      	// get the variant id
      	var variant = $("#product-select").val();
      
      	// add the variant to the cart
      	CartJS.addItem(parseInt(variant), 1, {}, {
          "success" : function(data, textStatus, XHR){
            window.setTimeout(function(){
              	console.log(data);
              	$("#product-loader").hide();
            	$("#product-form").hide();
            	var successString = data.product_title + " - " + data.variant_title + " was added to your <a class='link-under' href='/cart'>cart</a>."
            	$("#success-message").show().html(successString);
            }, 250);
          	
          },
          "error" : function(data, textStatus, XHR){
            window.setTimeout(function(){
            	$("#product-form").hide();
          		$("#success-message").show().html("Sorry, an error prevented this item from being added to your cart. Please reload the page and try again.");
          	}, 250);
          }
      	});
      
      	// hide the loader, and display success/error message
    });
    
  }
    
    
    
  $(window).load(function(){
    $("#main").css({"opacity" : "1"});
    window.setTimeout(function(){
  		$(".page-loader").fadeOut(75);
  	}, 40);               
  });

  $(".nav-toggle").click(function(e){
    e.preventDefault();
    $(".navigation-wrapper").fadeToggle(225);
  });
  
  $(".login-toggle").click(function(e){
    e.preventDefault();
    $(".search-modal").hide();
    $(".login-modal").fadeToggle(225);
  });
  
  $(".search-toggle").click(function(e){
    e.preventDefault();
    $(".login-modal").hide();
    $(".search-modal").fadeToggle(225);
  });
  
  $("#forgot-link").click(function(e){
    e.preventDefault();
    $(".login-form").hide();
    $(".forgot-form").show();
  });
  
  $("#cancel-forgot").click(function(e){
    e.preventDefault();
    $(".forgot-form").hide();
    $(".login-form").show();
  });
  
  $("#register-link").click(function(e){
    e.preventDefault();
    $(".login-form").hide();
    $(".register-form").show();
  });
  
  $("#cancel-register").click(function(e){
    e.preventDefault();
    console.log("well its working");
    $(".register-form").hide();
    $(".login-form").show();
  });



  
  
  
  


});